import { LoadingOutlined } from "@ant-design/icons";
import { Spin, Typography } from "antd";
import { useContext } from "react";
import LoaderContext from "../../Context/LoaderContext/Index";
import "./index.scss";

const Loader = () => {
  const { isLoading, loadingMessage } = useContext(LoaderContext);
  if (!isLoading) return null;
  return (
    <div className="loader_container">
      <Spin
        spinning={isLoading}
        indicator={<LoadingOutlined spin />}
        size="large"
        className="spinner"
      />
      <Typography.Text className="loading-message">
        {loadingMessage ? loadingMessage : "Please wait..."}
      </Typography.Text>
    </div>
  );
};

export default Loader;
